import axios from "axios";
import { DataPoint, Line } from "../charts/types";
import { generateRandomColor } from "../utils/ColorUtils";
import { buildEndpoint, FATURACAO_CLIENTES_EXTENSION } from "./api.service";


type resp = { fmonth: 'string', sum: string, totalvalue: number }



function ProcessResponseToLine(responseData: resp[], label: string, color?: string): Line {

    const dataPoints: DataPoint[] = responseData.map((d: resp) => {
        const splittedDate = `01-${d.fmonth}`.split('-');
        const reverseDate = [splittedDate[2], splittedDate[1], splittedDate[0]].join('-');
        return { x: new Date(reverseDate), y: d.totalvalue }
    }).sort((a: DataPoint, b: DataPoint) => (a.x as Date).getTime() - (b.x as Date).getTime());

    return { dataPoints: dataPoints, metadata: { label: label, color: color || generateRandomColor() } };

}


export async function getClientes() {
    const response = await axios.get(buildEndpoint(`/clients?page=1&take=1000000`));
    return response.data.data;

}


export async function getSimpleFaturacaoTotal(startDate?: string, endDate?: string): Promise<Line> {

    return (await axios.get(buildEndpoint(`/dashboard/faturacao-total?startDate=${startDate ? startDate : '1-1-2020'}&endDate=${endDate ? endDate : '31-12-2040'}`))).data;

}

export async function getFaturacaoTotal(startDate?: string, endDate?: string): Promise<Line> {

    const response: { data: resp[] } = await axios.get(buildEndpoint(`/dashboard/faturacao-total?startDate=${startDate ? startDate : '1-1-2020'}&endDate=${endDate ? endDate : '31-12-2040'}`));
    return ProcessResponseToLine(response.data, 'Despesas Faturação Fornecedores')

}

export async function getDespesasTotal(startDate?: string | null, endDate?: string | null): Promise<Line> {

    const response = await axios.get(buildEndpoint(`/dashboard/despesas-total?startDate=${startDate ? startDate : '1-1-2020'}&endDate=${endDate ? endDate : '31-12-2040'}`));
    return ProcessResponseToLine(response.data, 'Despesas Totais');

}

export async function getFaturacaoFornecedoresTotal(startDate?: string | null, endDate?: string | null): Promise<Line> {

    const response = await axios.get(buildEndpoint(`/dashboard/faturacao-fornecedores-total?startDate=${startDate ? startDate : '1-1-2020'}&endDate=${endDate ? endDate : '31-12-2040'}`));
    return ProcessResponseToLine(response.data, 'Faturação Fornecedores');
}

export async function getFaturacaoPorFornecedor(startDate?: string | null, endDate?: string | null, fornecedor?: string): Promise<Line | null> {

    const response = await axios.get(buildEndpoint(`/dashboard/faturacao-total-por-fornecedor?startDate=${startDate ? startDate : '1-1-2020'}&endDate=${endDate ? endDate : '31-12-2040'}&fornecedor=${fornecedor}`));
    if (response.data?.length) {
        const fornecedorName = response.data[0].fornecedor;
        return ProcessResponseToLine(response.data, fornecedorName);
    }

    return null;


}



export async function getTotalAReceber(startDate?: string | null, endDate?: string | null) {
    const response = await axios.get(buildEndpoint(`/dashboard/total-a-receber?startDate=${startDate ? startDate : '1-1-2020'}&endDate=${endDate ? endDate : '31-12-2040'}`));
    return response.data;
}

export async function getTotalAPagar(startDate?: string | null, endDate?: string | null) {
    const response = await axios.get(buildEndpoint(`/dashboard/total-a-pagar?startDate=${startDate ? startDate : '1-1-2020'}&endDate=${endDate ? endDate : '31-12-2040'}`));
    return response.data;
}


export async function getFaturacaoTotalPorCliente(startDate?: string | null, endDate?: string | null, clients?: any) {

    const response = await axios.get(buildEndpoint(`/dashboard/faturacao-total-por-cliente?startDate=${startDate ? startDate : '1-1-2020'}&endDate=${endDate ? endDate : '31-12-2040'}&clients=${clients ? JSON.stringify([...clients]) : ''}`));
    return response.data;
}



export async function getObrasToChart(startDate?: string | null, endDate?: string | null, clients?: any) {
    const response = await axios.get(buildEndpoint(`/dashboard/obras?startDate=${startDate ? startDate : '1-1-2020'}&endDate=${endDate ? endDate : '31-12-2040'}&clients=${clients ? JSON.stringify([...clients]) : ''}`));
    return response.data;
}

export async function getFaturacaoTotalObras() {
    const response = await axios.get(buildEndpoint('/dashboard/obras/total'));
    return response.data;
}

export async function getHistoricoAPagarEReceber() {
    const response = await axios.get(buildEndpoint('/dashboard/total-a-pagar-e-receber'));
    return response.data;
}


export async function getGanttData() {
    const response = await axios.get(buildEndpoint('/dashboard/obras/gantt'));
    response.data.forEach((o: any) => {
        o.entregas.map((e: any, idx: number) => {
            o.entregas[idx] = {
                ...e,
                startingDate: new Date(e.startingDate),
                publicDeliveryDate: new Date(e.publicDeliveryDate),
                realDeliveryDate: new Date(e.realDeliveryDate),
                productionReadyDate: new Date(e.productionReadyDate)
            }
        })
    })
    return response.data;
}


export async function saveMaquinaGanttPosition(maquinaGanttId: number, data: any) {
    return await axios.patch(buildEndpoint(`/dashboard/obras/gantt/${maquinaGanttId}`), data);
}